import React from 'react';
import { Heading, PageContent, Paragraph } from 'bumbag';

import LayoutPage from 'legacy/components/checkout/layout/Page';
import WithCleanSDK from 'legacy/components/WithCleanSDK';
export default function Expired() {
  return (
    <WithCleanSDK>
      <LayoutPage title="Expired session">
        <PageContent breakpoint="checkout">
          <Heading use="h6" marginTop="major-1" color="primary">
            <i className="far fa-exclamation-triangle" /> Your session has expired.
          </Heading>
          <Paragraph>If this is an error, ask your provider to re-send the payment request.</Paragraph>
        </PageContent>
      </LayoutPage>
    </WithCleanSDK>
  );
}
